<template>
  <b-container>
    <b-row v-loading="loading">
      <div style="margin: 15px 0">
        <router-link :to="{ name : 'PaymentsCreate' }"><b-button variant="dark" size="sm">Ödeme Ekle</b-button></router-link>
      </div>
      <div>
        <div class="table-responsive">
          <table style="table-layout:fixed" class="table table-striped table-bordered" v-if="!_.isEmpty(data)">
            <thead>
              <tr>
                <th style="width:50px">ID</th>
                <th>Ödeme Sistemi Adı</th>
                <th>Slug</th>
                <th>Durumu</th>
                <th style="width:150px">Detaylar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,key) in data" :key="key">
                <td>{{ item.id }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.slug }}</td>
                <td>{{ item.is_active == 1 ? 'Aktif' : 'Pasif' }}</td>
                <td>
                  <router-link style="margin-right:10px" :to="{ name: 'PaymentsDetail', params: { id : item.id } }"><b-button variant="primary" size="sm">Detaylar</b-button></router-link>
                  <b-button @click="remove(item.id)" slot="reference"  variant="danger" size="sm">Sil</b-button>
                </td>
              </tr>
            </tbody>
            <div class="block pagination">
              <el-pagination
                  v-if="paginateFilter.pageTotal > 0"
                  @size-change="handleSizeChange"
                  @current-change="fetch"
                  :current-page.sync="paginateFilter.page"
                  :page-sizes="sizes"
                  :page-size="paginateFilter.size"
                  layout="sizes, prev, pager, next"
                  :total="paginateFilter.pageTotal"
              ></el-pagination>
            </div> 
          </table>
        </div>
      </div>
    </b-row>
  </b-container>
</template>

<script>
  export default{
    name: 'PaymentsList',
    data(){
      return{
        sizes: [10, 20, 50, 100],
        loading:false,
        paginateFilter:{
          pageTotal: 0,
          size: 10,
          page: 1,
          types: []
        },
        data:[]
      }
    },
    watch:{
        "paginateFilter.types": function(val) {
          this.fetch(1, this.paginateFilter.size);
        },
    },
    created(){
      this.fetch();
    },
    methods:{
      remove(id){
        this.loading = true;
        axios.delete('/payment/' + id + '/delete')
        .then((response) => {
            if(response.status){
              this.$store.dispatch('alert/message', { type: 'success', title: 'Güncelleme Başarılı !'});
              this.fetch();
            }else{
              this.$store.dispatch('alert/message', { type: 'error', title: response.data.message });
            }
        })
        .catch((err) => {
        })
        .finally(()=>{
          this.loading = false;
        });
      },
      handleSizeChange(value){
        this.paginateFilter.size = value;
        this.fetch();
      },
      fetch(page = 1, size = null, silent = false){
        this.paginateFilter.page = page;

        if (!_.isNull(size)) 
        {
            this.paginateFilter.size = size;
        }
        if(!silent) this.loading = true;
        axios.get('/payment',{params: this.paginateFilter })
        .then((response) => {
          this.data = response.data.data;
          this.paginateFilter.pageTotal  	= response.data.data.total;
        })
        .catch((err) => {
        })
        .finally(()=>{
          this.loading = false;
        });
      },
    }
  }
</script>